import { z } from 'zod'

/**
 * The type of an event phase. A `transition` is a flip/turnover between two
 * arrangements; everything else is `main`. Kept in sync with the Prisma
 * `PhaseType` enum.
 */
export const PHASE_TYPES = ['main', 'transition'] as const

export const phaseTypeSchema = z.enum(PHASE_TYPES)

export type PhaseType = z.infer<typeof phaseTypeSchema>
